<template>
  <div class="list-area ebook-list">
    <div class="list-header">
      <div class="left-area">
        <div class="tit-area title--hover" @click="goEBook">
          <p class="tit">전자책</p>
        </div>
      </div>
      <div class="right-area">
        <!-- controll bar -->
        <div class="ebook-control-bar">
          <div class="swiper-button-prev swiper-ebook-prev" slot="button-prev">
            <span class="material-icons">arrow_back_ios</span>
          </div>
          <!-- pause -->
          <button v-show="swiperPlay" class="swiper-button-pause" @click="swiperPlay = false">
            <img src="~@/assets/images/portal/icon/main/icon_pause.svg" alt="전자책 컨텐츠 일시정지"/>
          </button>
          <!-- play -->
          <button v-show="!swiperPlay" class="swiper-button-pause" @click="swiperPlay = true">
            <img src="~@/assets/images/portal/icon/main/icon_play.svg" alt="전자책 컨텐츠 재생"/>
          </button>
          <div class="swiper-button-next swiper-ebook-next ml5" slot="button-next">
            <span class="material-icons">arrow_forward_ios</span>
          </div>
        </div>
        <div class="custom-label">
          <span class="label" :class="'new' === tab && 'is-checked'" @click="changeTab('new')">신규등록</span>
          <span class="label" :class="'popular' === tab && 'is-checked'" @click="changeTab('popular')">최다조회</span>
        </div>
      </div>
    </div>
    <!-- body -->
    <div class="list-body">
      <div class="data-list">
        <div class="no-data" v-if="!$fetchState.pending && 1 > ebookList.length">
          <i class="material-icons">error_outline</i>
          <p>데이터가 없습니다.</p>
        </div>
        <!-- swiper -->
        <swiper v-else ref="dataListSwiper" class="data-list-swiper"
                :options="dataListSwiperOptions">
          <swiper-slide v-for=" item in ebookList" :key="item.oid"
                        @click.native="goToViewUrl( item.linkViewUrl )">
            <div class="inner-wrap">
              <div class="thumb-area pd-none" :class="item.isNoImage && 'no-image'">
                <img :src="item.thumbNailUrl" :alt="item.name"/>
              </div>
              <div class="txt-area">
<!--                <div class="top-area">-->
<!--                  <div class="inner-top">-->
<!--                    <span v-text="item.extraInfoMap.category"></span>-->
<!--                  </div>-->
<!--                  <div class="inner-tit" v-text="item.name"></div>-->
<!--                </div>-->
                <div class="bottom-area">
                  <span class="inner-date" v-text="item.inputDate"></span>
                  <div class="inner-view">
                    <span>조회</span>
                    <span v-text="$util.formatUtils.addCommas(item.extraInfoMap.viewCount)"></span>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import noImage from "@/assets/images/portal/sample/no_image.png";

const URL_EBOOK = process.env.SYSTEM.EBOOK.URL;
const URL_LIST_EBOOK = "/api/portlet/v1/portalPortletApi_ebookList";

const ORDER_BY_WORD = {
  INPUT_DATE : "IN,D", // 신규등록
  VIEW_CNT : "VI,D", // 최다조회
}

export default {
  name: "ThePortletEbookList",
  data() {
    return {

      // 신규등록(new) / 최다조회(popular)
      tab : "new",
      orderByWord : ORDER_BY_WORD.INPUT_DATE,

      // EbookList
      ebookList: [],

      // pageSize
      pageSize: 2,

      dataListSwiperOptions: {
        autoplay: {
          delay: 7000,
          disableOnInteraction: false,
        },
        slidesPerView: 1,
        slidesPerGroup: 1,
        navigation: {
          nextEl: ".swiper-ebook-next",
          prevEl: ".swiper-ebook-prev"
        },
      },
      // 스와이퍼 재생
      swiperPlay: true,
      mobileYn: false,
    }
  },

  fetch() {
    this.getEbookList( this.pageSize );
  },

  computed: {
    ...mapGetters( {
      loginUser : "common/login/loginUserInfo",
    } ),

    swiper() {
      return this.$refs.dataListSwiper.swiper;
    },

    // 로그인이 되어 있는지 여부
    isLoggedIn() {
      return this.$validate.isNotEmpty( this.loginUser.userOid )
    },

    // 관리자면 true
    isAdmin() {
      return this.$constant.USER_TYPE.ADMIN.KEY === this.loginUser.userType;
    },

    // 강원교직원이면 true
    isGangWonStaff() {
      return this.$constant.USER_TYPE.STAFF_GANGWON.KEY === this.loginUser.userType || this.isAdmin;
    },

    // 일반교직원이면 true
    isStaff() {
      return this.$constant.USER_TYPE.STAFF.KEY === this.loginUser.userType || this.isAdmin;
    },
  },

  mounted() {
    this.reactiveMobileYn( event );
    window.onresize = this.reactiveMobileYn;
  },

  watch: {
    swiperPlay() {
      if ( this.swiperPlay ) {
        this.swiper.autoplay.start();
      }
      else {
        this.swiper.autoplay.stop();
      }
    }
  },

  methods: {

    /**
     * 탭 변경 시
     *
     * @param tab - 신규등록(new) / 최다조회(popular)
     */
    changeTab( tab ) {

      this.tab = tab;

      // 신규등록
      if ( "new" === this.tab ) {
        this.orderByWord = ORDER_BY_WORD.INPUT_DATE;
      }
      // 최다조회
      else if ( "popular" === this.tab ) {
        this.orderByWord = ORDER_BY_WORD.VIEW_CNT;
      }

      this.getEbookList( this.pageSize );
    },

    /**
     * 전자책 리스트를 받아옵니다.
     * */
    async getEbookList( pageSize ) {

      const param = {
        pageSize: pageSize,
        orderByWord : this.orderByWord,
      }

      const { data } = await this.$axios.post( URL_LIST_EBOOK, param );

      if ( this.$validate.isEmpty( data.data ) ) {
        this.ebookList = [];
        return;
      }

      data.data.forEach( item => {
        item.isNoImage = this.$validate.isEmpty( item.thumbNailUrl );
        item.thumbNailUrl = this.getThumbnailPath( item.isNoImage, item.thumbNailUrl );
      } );

      this.ebookList = data.data;
    },

    goToViewUrl( viewLink ) {

      if ( this.$validate.isEmpty( viewLink ) ) {
        return "";
      }

      window.open( viewLink, "_black" );

    },

    /**
     * 썸네일이 없을 경우 no-data 이미지를 가져옵니다.
     * */
    getThumbnailPath( isNoImage, thumbNail ) {
      return isNoImage ? noImage : thumbNail;
    },

    /**
     * 반응형 웹 size
     */
    // reactive Resize Event
    reactiveMobileYn: function reactiveMobileYn( event, breakPoint = 1024 ) {
      // desktop
      (window.screen.width > breakPoint) ? this.mobileYn = false : this.mobileYn = true;

    },

    /**
     * 전자책으로 이동
     */
    goEBook() {
      // 로그인이 되어 있고 교직원이 아닐 경우
      if ( this.isLoggedIn && !( this.isGangWonStaff || this.isStaff ) ) {
        this.$util.rsAlertUtils.rsAlert( { title : "교직원 회원만 이용이 가능합니다.", contents : "", state : "warning" } );
        return;
      }

      // SSO_MODE가 아닐 경우
      if ( !this.$constant.SSO_MODE ) {
        window.open( URL_EBOOK );
        return;
      }

      // SSO_MODE일 경우
      // 로그인하지 않았을 경우 accounts 로 이동
      if ( !this.isLoggedIn ) {
        window.open( `${process.env.SYSTEM.ACCOUNTS.URL}/v1/login/login?sys=ebook&eox=${URL_EBOOK}` );
      }
      // 전자책 메인 화면으로 이동
      else {
        window.open( URL_EBOOK );
      }
    },
  }
}
</script>
<style scoped>
</style>
